module.exports = __webpack_public_path__ + "img/DOTA-BP1.5e40184a.png";